import MetaProperties from "./MetaProperties";

export default class MetaModel {
    public pagination: MetaProperties = new MetaProperties();
}